import { getOrderTaxSummary } from "./orderTaxes";

export function getBusinessOrderTaxes(order, response) {
  const summary = getOrderTaxSummary(order);
  if (summary.fees?.length || !response) return summary;

  const data = response.data ?? response;
  const metadata = data.meta_data ?? data;
  const values = Array.isArray(metadata)
    ? metadata.reduce((taxes, item) => {
        if (item.meta_key) taxes[item.meta_key] = item.meta_value;
        else Object.assign(taxes, item);
        return taxes;
      }, {})
    : metadata;
  const readRate = (key, apiKey) => {
    const value = values[apiKey] ?? values[key];
    const rate = value == null || value === "" ? 0 : Number(value);
    if (!Number.isFinite(rate) || rate < 0 || rate > 100) {
      throw new Error("Invalid business tax percentage");
    }
    return rate;
  };
  if (!["businessTaxRate", "businessConvTourTaxRate", "business_tax", "business_conv_tour_tax"]
    .some((key) => key in values)) {
    throw new Error("Business taxes were not returned");
  }
  if (summary.subtotal === null) return summary;
  const round = (value) => Math.round((value + Number.EPSILON) * 100) / 100;
  const base = summary.subtotal + summary.delivery;
  const fees = [
    { label: "Service Fees", rate: 10 },
    { label: "Business Tax", rate: readRate("business_tax", "businessTaxRate") },
    { label: "Convention and Tourism Tax", rate: readRate("business_conv_tour_tax", "businessConvTourTaxRate") },
  ].map((fee) => ({
    ...fee,
    amount: summary.subtotal > 0 ? round(base * fee.rate / 100) : 0,
  }));
  return {
    ...summary,
    fees,
    rate: round(fees.reduce((sum, fee) => sum + fee.rate, 0)),
    amount: round(fees.reduce((sum, fee) => sum + fee.amount, 0)),
  };
}
